import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { LayoutsModule } from "./layouts/layouts.module";
import { EntitiesModule } from "./entities/entities.module";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { CoreModule } from "./core/core.module";
import { DevicesModule } from "./entities/devices/devices.module";
import { SortablejsModule } from "angular-sortablejs/dist";
import { LoadingModule, ANIMATION_TYPES } from "ngx-loading";
import {
  MatDialogModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
} from "@angular/material";
import { ChartsModule } from "ng2-charts";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { FormsModule } from "@angular/forms";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import "hammerjs";
import { HAMMER_GESTURE_CONFIG } from "@angular/platform-browser";
import { GestureConfig } from "@angular/material";
import { CookieService } from "ngx-cookie-service";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    EntitiesModule,
    SharedModule,
    CoreModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.threeBounce,
      primaryColour: "#ea524b",
      secondaryColour: "#ea524b",
      tertiaryColour: "#ea524b",
    }),
    SortablejsModule.forRoot({
      animation: 800,
      ghostClass: "ghostCard",
    }),
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormsModule,
    InfiniteScrollModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [MatProgressBarModule, MatProgressSpinnerModule],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    CookieService,
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts